import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";

const BASE_SCREEN_WIDTH = 1436;
const BASE_GRAPH_CONTENT_WIDTH = 310;

export const AsideGraphSkeleton = ({ locals }) => {
  const [chartSize, setChartSize] = useState({ width: 250, height: 154 });
  const webAppTheme = locals.activeUser.webAppTheme || "dark";
  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";

  useEffect(() => {
    if (window) {
      const windowWidth = window.innerWidth;
      const chartWidth =
        (windowWidth * BASE_GRAPH_CONTENT_WIDTH) / BASE_SCREEN_WIDTH;
      setChartSize({ ...chartSize, width: chartWidth });
    }
  }, []);

  return (
    <ContentLoader
      width={chartSize.width}
      height={chartSize.height}
      viewBox={`0 0 300 200`}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      speed={1}
      title="Loading metrics..."
    >
      <circle cx="5" cy="21" r="5" />
      <circle cx="5" cy="51" r="5" />
      <circle cx="5" cy="81" r="5" />
      <circle cx="5" cy="111" r="5" />
      <circle cx="5" cy="141" r="5" />
      <circle cx="5" cy="171" r="5" />

      <rect x="30" y="121" rx="4" ry="4" width="25" height="55" />
      <rect x="60" y="102" rx="4" ry="4" width="25" height="74" />
      <rect x="90" y="56" rx="4" ry="4" width="25" height="120" />
      <rect x="120" y="136" rx="4" ry="4" width="25" height="40" />
      <rect x="150" y="118" rx="4" ry="4" width="25" height="58" />
      <rect x="180" y="102" rx="4" ry="4" width="25" height="74" />
      <rect x="210" y="121" rx="4" ry="4" width="25" height="55" />
      <rect x="240" y="26" rx="4" ry="4" width="25" height="150" />
      <rect x="270" y="136" rx="4" ry="4" width="25" height="40" />

      <rect x="35" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="65" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="95" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="125" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="155" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="185" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="215" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="245" y="190" rx="4" ry="4" width="15" height="6" />
      <rect x="275" y="190" rx="4" ry="4" width="15" height="6" />
    </ContentLoader>
  );
};
